import React from 'react';
import './Spaltgeschwindigkeit.css';
import { calculateSpaltgeschwindigkeit } from '../calculations/airflow';


class Spaltgeschwindigkeit extends React.Component {
  //Ermittelt die effektive Spaltgeschwindigkeit
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  _getSpaltgeschwindigkeit(){
      //Berechnet die Luftgeschwindigkeit im Kulissenspalt
      let vs = calculateSpaltgeschwindigkeit({
          Volumenstrom: this.props.Volumenstrom,
          Kulissenspaltbreite: this.props.Kulissenspaltbreite,
          Kulissenhoehe: this.props.Kulissenhoehe,
          AnzahlKulissen: this.props.AnzahlKulissen,
      });
      this.props.SpaltgeschwindigkeitChange(vs);
      return vs;
  }

  render() {
      return (
        <>{this._getSpaltgeschwindigkeit().toFixed(2)}<span> m/s</span>
        </>


    );
  }
}
export default Spaltgeschwindigkeit;
